<template>
  <section>
    <div class="flex flex-wrap mt-4">
      <IndexNavbar />
      <div class="w-full mt-20 mb-12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0"
        >
          <div class="rounded-t bg-white mb-0 px-6 py-6">
            <div class="text-center flex justify-between">
              <h6 class="text-dark text-m">Coming Soon</h6>
            </div>
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <br />
              <div class="flex flex-wrap">
                <div class="w-full px-4">
                  <div class="relative w-full mb-3">
                    <div class="text-center mt-8">
                      <br />
                      <i class="fas fa-landmark text-4xl mb-4 text-red-500"></i>
                      <br />
                      <h4 class="text-red-500 text-xl">
                        Special Investments Bounty and Lottery are not available
                        at the moment.
                      </h4>

                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <FooterComponent />
  </section>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";


export default {
  components: {
        IndexNavbar,
        FooterComponent,

  },
};
</script>
